import { Routes } from '@angular/router';
import { Login } from './login/login';
import { Home } from './home/home';
import { MassiveUpload } from './massive-upload/massive-upload';
import { IbercajaUpload } from './ibercaja-upload/ibercaja-upload';
import { MassiveServicesUpload } from './massive-services-upload/massive-services-upload';
import { MassiveServices2Upload } from './massive-services2-upload/massive-services2-upload';
import { AntecedentValueCheckUpload } from './antecedent-value-check-upload/antecedent-value-check-upload';
import { ExternalQualityControlUpload } from './external-quality-control-upload/external-quality-control-upload';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: Login },
  { path: 'home', component: Home },
  { path: 'massive-upload', component: MassiveUpload },
  { path: 'ibercaja-upload', component: IbercajaUpload },
  { path: 'massive-services-upload', component: MassiveServicesUpload },
  { path: 'massive-services2-upload', component: MassiveServices2Upload },
  { path: 'antecedent-value-check-upload', component: AntecedentValueCheckUpload },
  { path: 'external-quality-control-upload', component: ExternalQualityControlUpload }
];
